module.exports = __webpack_public_path__ + "static/media/sinkLeaky.573f9847.png";